import { Invoice, InvoicePaymentStatusEnum } from "@sb1finans/new-api/dist/api";

/** Include overdue and collection invoices when choosing the next payment. */
export const getNextUnpaidInvoice = (invoices: Invoice[]): Invoice | undefined =>
  invoices
    .filter(invoice =>
      invoice.paymentStatus === InvoicePaymentStatusEnum.Open ||
      invoice.paymentStatus === InvoicePaymentStatusEnum.Expired ||
      invoice.paymentStatus === InvoicePaymentStatusEnum.InCollection
    )
    .sort((a, b) => new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime())[0];
